module.exports = __webpack_public_path__ + "img/dowload.6b0f0afb.svg";